var map = {
	"./1.jpg": 193,
	"./2.jpg": 194,
	"./3.jpg": 195,
	"./4.jpg": 196,
	"./5.jpg": 197,
	"./6.jpg": 198,
	"./7.jpg": 199,
	"./8.jpg": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;